import { HideToast, ShowToast } from '@/store/toast/actions';

import { INFO_TOAST_DURATION } from '@/services/constants';
import { put } from 'redux-saga/effects';

export function* infoToast(msg: string): any {
    yield put(
        ShowToast({
            severity: 'info',
            message: msg,
            duration: INFO_TOAST_DURATION,
            onClose: HideToast,
        })
    );
}
